import { SELECTOR_DASHBOARDS } from "./selectorDashboards";

const asset = (folder, name) => ({ name, path: `${folder}${name}` });
const canonical = ["icon", "wordmark", "lockup"].flatMap(kind =>
  ["light", "dark"].flatMap(tone => [
    `mindGAME-${kind}-${tone}.svg`,
    `mindGAME-${kind}-${tone}-animated.svg`,
    `mindGAME-${kind}-${tone}-512.png`,
    `mindGAME-${kind}-${tone}-2048.png`,
  ]).map(name => asset("brand/mindgame/", name)));

export const BRAND_ASSET_GROUPS = [
  { id: "color-ring", title: "Color-ring icon concept / preview only", assets: [
    "mindGAME-icon-color-ring.svg", "mindGAME-icon-color-ring-animated.svg",
  ].map(name => asset("brand/mindgame/", name)) },
  { id: "canonical", title: "Current vector masters & transparent exports", assets: canonical },
  { id: "icon", title: "Tree, monogram & spray-paint marks", assets: [
    "mG Spray Paint Colored.png", "mG Spray Paint White.png", "mG_black_generated_ALT.png",
    "mG_black_on_cream.png", "mG_black_transparent.png", "mG_color_on_black.png",
    "mG_color_on_cream.png", "mG_coral_transparent.png", "mG_cream_transparent.png",
    "mG_cyan_transparent.png", "mG_primary_color_ORIGINAL.png", "mG_primary_color_transparent.png",
    "mG_white_generated_ALT.png", "mG_white_on_black.png", "mG_white_transparent.png", "mindGAME Tree Logo.png",
  ].map(name => asset("redesign/logos/icon/", name)) },
  { id: "wordmark", title: "Wordmarks & legacy treatments", assets: [
    "Distressed MindGAME Logo with Color Bars.png", "mindGAME Jura White.png", "mindGAME_Jura_editable_text.svg",
    "mindGAME_black_generated_ALT.png", "mindGAME_black_on_cream.png", "mindGAME_black_transparent.png",
    "mindGAME_color_on_black.png", "mindGAME_cream_transparent.png", "mindGAME_login_approved_ORIGINAL.png",
    "mindGAME_primary_cream_coral_transparent.png", "mindGAME_white_generated_ALT.png", "mindGAME_white_transparent.png",
  ].map(name => asset("redesign/logos/wordmark/", name)) },
  { id: "lockup", title: "Combined & legacy lockups", assets: [
    "mG_mindGAME_black_transparent.png", "mG_mindGAME_color_ORIGINAL.png", "mG_mindGAME_color_on_black.png",
    "mG_mindGAME_cream_transparent.png", "mG_mindGAME_primary_color_transparent.png", "mG_mindGAME_white_transparent.png",
  ].map(name => asset("redesign/logos/lockup/", name)) },
  { id: "platforms", title: "Dashboard & platform branding", assets: [...new Set([
    ...SELECTOR_DASHBOARDS.flatMap(dashboard => [dashboard.icon, dashboard.logo]),
    "Calendar Logo.png", "Discord Logo.png", "Google Icon.png", "mindGAME Brain Logo.png",
    "mindgame_logo.png", "Mobile Android iOS Logo.png", "Nintendo Logo.png", "PlayStation Logo.png",
    "Steam Icon.png", "Steam Logo Calendar.png", "TikTok Icon.png", "Twitch Icon.png",
    "Xbox Logo.png", "YouTube Icon.png", "YouTube Logo Header.png", "YouTube Logo.png",
  ])].map(name => asset("", name)) },
  { id: "elements", title: "Interface icons, labels & guides", assets: [
    "calendar-menu.png", "change-password.png", "confirm-email.png", "country-menu.png", "Create Bubble Text.png",
    "create-account.png", "Enter Bubble Text.png", "Filter Button.png", "login.png", "MFA Icon.png",
    "mindshare-menu.png", "mobile-menu.png", "profile.png", "profile-menu.png", "roblox-menu.png", "save.png",
    "scorecards-menu.png", "search-menu.png", "sign-in.png", "sign-up.png", "Steam Card Guide.png",
    "steam-menu.png", "steam-sidebar.png", "tiktok-menu.png", "tiktok-sidebar.png", "Twitch Card Guide.png",
    "Twitch Market Mind Guide.png", "Twitch Streamers Guide.png", "twitch-menu.png",
  ].map(name => asset("", name)) },
];

export const BRAND_COLORS = [
  ["White / live lettering", "#ffffff"], ["Coral / signature bar", "#f4564d"],
  ["Ivory / signature bar", "#e9e0d5"], ["Cyan / signature bar & cursor", "#45e4f5"],
  ["Threshold blue", "#20a5bb"], ["Threshold coral", "#ff554d"],
  ["Paper / interface text", "#e8e2db"], ["Vault background", "#07090b"],
  ["Dark vector artwork", "#11191c"],
];
